import React, { useEffect, useState } from 'react'
import {
    Table,
    Tabs,
    Tab,
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton
} from "@mui/material";
import { toast } from 'react-toastify';
import DownloadIcon from "@mui/icons-material/Download";

import { Pagination } from '@mui/material';
import { get_gio_buying_list, gioo_buying_cancel_request, get_gio_buying_detail, get_syndicate_buying_list, get_syndicate_buying_detail, syndicate_buying_cancel_request, get_purchase_bank_details, get_all_bank_details } from '../../../api/ControllApi';
import { useSearchParams } from "react-router-dom";
import { gioo_transaction_list, marketplace_transaction_list, residential_transaction_list, syndicate_transaction_list, rental_transaction_list } from '../../../api/Payment';
import TransactionDetailsModal from '../../../components/common/TransactionDetailsModal';



const Transactions = () => {
    const [loading, setLoading] = useState(true);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [loadingDetails, setLoadingDetails] = useState(false);

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRows, setTotalRows] = useState(0);

    const [detailsPage, setDetailsPage] = useState(1);
    const [detailsRowsPerPage, setDetailsRowsPerPage] = useState(10);
    const [totalDetailsRows, setTotalDetailsRows] = useState(0);

    const [openModal, setOpenModal] = useState(false);
    const [selectedTransaction, setSelectedTransaction] = useState([]);

    const [buyingList, setBuyingList] = useState([]);
    const [tabIndex, setTabIndex] = useState(0);
    const [searchParams, setSearchParams] = useSearchParams();

    const [openTransactionModal, setOpenTransactionModal] = useState(false);
    const [selectedSyndicatePropertyId, setSelectedSyndicatePropertyId] = useState(null);
    const [selectedTransactionId, setSelectedTransactionId] = useState(null);
    const [isPreviewMode, setIsPreviewMode] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const [allBankDetails, setAllBankDetails] = useState([]);


    useEffect(() => {
        const tab = searchParams.get("tab");

        if (tab === "rentalYield") {
            setTabIndex(1);
        } else if (tab === "syndicate") {
            setTabIndex(2);
        } else if (tab === "residential") {
            setTabIndex(3);
        } else if (tab === "marketPlace") {
            setTabIndex(4);
        } else {
            setTabIndex(0)
        }
    }, []);

    const handleOpenModal = (transaction) => {
        setSelectedTransaction(transaction);
        setOpenModal(true);
    };
    const handleCloseModal = () => {
        setSelectedTransaction([]);
        setOpenModal(false);
    };
    const handleOpenDialog = (id) => {
        setSelectedId(id);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setSelectedId(null);
    };

    const handleTabChange = (index) => {
        setTabIndex(index);
        setPage(1);

        setSearchParams({
            tab: index === 1 ? "rentalYield" : index === 2 ? "syndicate" : index === 3 ? "residential" : index === 4 ? "marketPlace" : "gioo"
        });
    };



    const fetchBuyingList = async (tab, page = 1, perPage = 10) => {
        setLoading(true); // Start loading
        try {
            let res;
            if (tab === 0) {
                res = await gioo_transaction_list(page);
            } else if (tab === 1) {
                res = await rental_transaction_list(page);
            } else if (tab === 2) {
                res = await syndicate_transaction_list(page);
            } else if (tab === 3) {
                res = await residential_transaction_list(page);
            } else if (tab === 4) {
                res = await marketplace_transaction_list(page);
            }

            const initialData = res?.data || [];
            
            // Fetch all bank details if not already fetched or on every list refresh
            let bankDetails = allBankDetails;
            if (bankDetails.length === 0) {
                try {
                    const bankRes = await get_all_bank_details();
                    if (bankRes.success && Array.isArray(bankRes.data)) {
                        bankDetails = bankRes.data;
                        setAllBankDetails(bankRes.data);
                    }
                } catch (e) {
                    console.error("Error fetching all bank details:", e);
                }
            }

            // Map and mark items with existing bank details
            const updatedData = initialData.map((item) => {
                const propId = item.property_id || item.id;
                const type = tab === 1 ? "rental" : tab === 2 ? "syndicate" : tab === 3 ? "plot" : tab === 4 ? "market" : "gioo";
                
                // Check if this property has bank details in the allBankDetails set
                const isAdded = bankDetails.some(bd => 
                    (String(bd.property_id) === String(propId)) && 
                    (String(bd.type) === String(type))
                );
                
                return { ...item, is_purchase_bank_details: isAdded || item.is_purchase_bank_details };
            });

            setBuyingList(updatedData);
            setTotalRows(res.meta?.total || res.data.length || 0);
        } catch (err) {
            console.error("Error fetching transactions:", err);
        } finally {
            setLoading(false); // Stop loading
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        fetchBuyingList(tabIndex, newPage, rowsPerPage);
    };

    const handleChangeRowsPerPage = (event) => {
        const newRows = parseInt(event.target.value, 10);
        setRowsPerPage(newRows);
        setPage(1);
        fetchBuyingList(tabIndex, 1, newRows);
    };

    const handleViewBankDetails = async (propertyId, type) => {
        setLoading(true);
        try {
            const res = await get_purchase_bank_details(propertyId, type);
            if (res.status === true || res.success === true || res.data) {
                setPreviewData(res.data);
                setIsPreviewMode(true);
                setSelectedSyndicatePropertyId(propertyId);
                setOpenTransactionModal(true);
            } else {
                toast.error(res.message || "Failed to fetch bank details");
            }
        } catch (err) {
            toast.error("Error fetching bank details");
        } finally {
            setLoading(false);
        }
    };

    const handleViewDetail = async (id, page = 1) => {
        setLoadingDetails(true);
        try {
            let res =
                tabIndex === 0
                    ? await get_gio_buying_detail(id, page)
                    : (tabIndex === 1 || tabIndex === 2)
                        ? await get_syndicate_buying_detail(id, page)
                        : await get_syndicate_buying_detail(id, page);

            if (res?.status) {
                setSelectedTransaction(res.data);
                setTotalDetailsRows(res.meta?.total || res.data.length || 0);
                setDetailsPage(page);
                setOpenModal(true);
            } else {
                toast.error(res?.message || "Failed to fetch details");
            }
        } catch (err) {

            toast.error("Something went wrong while fetching details");
        } finally {
            setLoadingDetails(false);
        }
    };

    useEffect(() => {
        fetchBuyingList(tabIndex);
    }, [tabIndex]);



    return (
        <div>
            <Typography variant="h5" fontWeight={500} mb={{ xs: 0, sm: 0 }}>
                Transaction History
            </Typography>


            <Box
                sx={{
                    display: "flex",
                    gap: 2,
                    mb: 3,
                    mt: 3,
                    flexWrap: { xs: "wrap", sm: "nowrap" },
                    justifyContent: { xs: "center", sm: "flex-start" },
                    overflowX: { xs: "auto", sm: "visible" },
                }}
            >
                {["Gioo Nano plots", "Gio Rental Yield", "Gio Rental Yield – Syndicate Plot", "Flats / Villas", "Land"].map((label, index) => (
                    <Box
                        key={index}
                        onClick={() => handleTabChange(index)}
                        sx={{
                            px: 3,
                            py: 1,
                            mb: 1,
                            borderRadius: 2,
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                            fontWeight: tabIndex === index ? 600 : 400,
                            backgroundColor: tabIndex === index ? "primary.main" : "#f0f0f0",
                            color: tabIndex === index ? "#fff" : "#000",
                            boxShadow: tabIndex === index ? 3 : 1,
                            transition: "all 0.2s",
                            minWidth: "max-content",
                            "&:hover": {
                                backgroundColor:
                                    tabIndex === index ? "primary.dark" : "#e0e0e0",
                            },
                        }}
                    >
                        {label}
                    </Box>
                ))}
            </Box>

            <TableContainer component={Paper} sx={{ mt: 4 }}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "primary.light", color: "white" }}>
                            <TableCell>Property Name</TableCell>

                            <TableCell>Property Type</TableCell>
                            <TableCell>Payment Mode</TableCell>

                            <TableCell>Amount</TableCell>
                            {(tabIndex === 1 || tabIndex === 2) && (
                                <>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Tracking</TableCell>
                                </>
                            )}
                            <TableCell>Download Invoice</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ? (
                            <TableRow>
                                <TableCell colSpan={(tabIndex === 1 || tabIndex === 2) ? 7 : 5} align="center">
                                    Loading...
                                </TableCell>
                            </TableRow>
                        ) :

                            buyingList.length > 0 ? (
                                buyingList.map((item) => (
                                    <TableRow key={item.transaction_id || item.id}>
                                        <TableCell>{item?.property_name || "-"}</TableCell>

                                        <TableCell>{item?.property_type || (tabIndex === 1 ? "GIO Rental Yield" : tabIndex === 2 ? "GIO Rental Yield – Syndicate Plot" : "Not Found")}</TableCell>
                                        <TableCell>{item?.payment_type ? item.payment_type : "-"}</TableCell>
                                        <TableCell>{item?.amount || "-"}</TableCell>

                                        {(tabIndex === 1 || tabIndex === 2) && (
                                            <>
                                                <TableCell>
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        onClick={() => {
                                                            const type = tabIndex === 1 ? "rental" : tabIndex === 2 ? "syndicate" : tabIndex === 3 ? "plot" : tabIndex === 4 ? "market" : "gioo";
                                                            if (item.is_purchase_bank_details) {
                                                                handleViewBankDetails(item.property_id || item.id, type);
                                                            } else {
                                                                setIsPreviewMode(false);
                                                                setPreviewData(null);
                                                                setSelectedSyndicatePropertyId(item.property_id || item.id);
                                                                setSelectedTransactionId(item.transaction_id || item.id);
                                                                setOpenTransactionModal(true);
                                                            }
                                                        }}
                                                        sx={{
                                                            textTransform: "none",
                                                            backgroundColor: "primary.main",
                                                            borderRadius: "50px",
                                                            fontSize: "11px",
                                                        }}
                                                    >
                                                        {item.is_purchase_bank_details ? "Bank Details Added" : "Add Transaction Details"}
                                                    </Button>
                                                </TableCell>
                                                <TableCell>
                                                    {(!item.dtdc_id && !item.tracking_id) ? (
                                                        <Typography variant="body2" color="text.secondary">
                                                            Processing
                                                        </Typography>
                                                    ) : (
                                                        <Typography variant="body2">
                                                            {item.dtdc_id || item.tracking_id}
                                                        </Typography>
                                                    )}
                                                </TableCell>
                                            </>
                                        )}

                                        <TableCell>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                href={item?.download_invoice || item?.invoice_url}
                                                target="_blank"
                                                startIcon={<DownloadIcon />}
                                            >
                                                Download
                                            </Button>
                                        </TableCell>

                                    </TableRow>
                                )))
                                : (
                                    <TableRow>
                                        <TableCell colSpan={(tabIndex === 1 || tabIndex === 2) ? 7 : 5} align="center">
                                            No data found
                                        </TableCell>
                                    </TableRow>
                                )}
                    </TableBody>
                </Table>
            </TableContainer>


            {!loading && totalRows > rowsPerPage && (
                <Box display="flex" justifyContent="center" mt={2}>
                    <Pagination
                        count={Math.ceil(totalRows / rowsPerPage)}
                        page={page}
                        onChange={handleChangePage}
                        color="primary"
                    />
                </Box>
            )}


            <TransactionDetailsModal
                open={openTransactionModal}
                onClose={() => {
                    setOpenTransactionModal(false);
                    setIsPreviewMode(false);
                    setPreviewData(null);
                }}
                propertyId={selectedSyndicatePropertyId}
                transactionId={selectedTransactionId}
                type={tabIndex === 1 ? "rental" : tabIndex === 2 ? "syndicate" : tabIndex === 0 ? "gioo" : "other"}
                onSuccess={() => fetchBuyingList(tabIndex, page)}
                isPreview={isPreviewMode}
                data={previewData}
            />
        </div>
    );
};


export default Transactions
